<template>
  <div class="text-xs-center">
    <v-card>
      <v-toolbar dark  color="#4A76A8" flat  height="42">
        <v-toolbar-title  >  Удаление задания   </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="cancel()">mdi-close</v-icon>
      </v-toolbar>

       <v-card-text scrollable>
Подтвердите удаление <span style="color:green; font-size:1.2em"> {{tasks.deleteTask.taskId.name}} </span>  отменить данное действие будет невозможно
       </v-card-text>

       <v-divider></v-divider>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn
           color="#4A76A8"
           flat small
           @click="cancel()"
         >
           Отмена
         </v-btn>
         <v-btn
         :loading="loading"
           color="red" class="white--text"
            small
           @click="ok()"
         >
           Удалить
         </v-btn>
       </v-card-actions>
     </v-card>
  </div>
</template>




<script>
import axios from 'axios'
export default {
props: ['tasks'],
 data: function(){
  return {
loading : false
  }
},

methods: {
 ok: function(){
this.loading = true



   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_delete.php', {
        method: 'POST',
        data: {
          id: this.tasks.deleteTask.taskId.task_id
        }
      })
      .then( response => {
        this.tasks.deleteTask.modal = false
        this.loading = false
        axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
             method: 'POST',
             data: {
               contentType: 'groups'
             }
           })
           .then( response => {
             this.tasks.tasksList = response.data
           })

      })
 },
 cancel: function(){
   this.tasks.deleteTask.modal = false
 }

}
}
</script>

<style  >

</style>
